<template>
    <div class="list-body">


        <slot name="other">

        </slot>

        <div v-if="!inlineBtnGroup" :style="{textAlign:btnGroupDirection}">
            <el-button-group v-if="showBtnGroup" class="btn-group">
                <slot name="btn-group">
                    <el-button icon="el-icon-plus" >新增</el-button>
                    <el-button icon="el-icon-edit" >编辑</el-button>
                    <el-button icon="el-icon-delete">删除</el-button>
                    <el-button icon="el-icon-search">查询</el-button>
                </slot>
            </el-button-group>
        </div>

        <fb-main-body class="table-list">

            <div v-if="inlineBtnGroup" :style="{textAlign:btnGroupDirection}" style="margin-bottom: 20px">
                <el-button-group v-if="showBtnGroup" class="btn-group">
                    <slot name="btn-group">
                        <el-button icon="el-icon-plus" >新增</el-button>
                        <el-button icon="el-icon-edit" >编辑</el-button>
                        <el-button icon="el-icon-delete">删除</el-button>
                        <el-button icon="el-icon-search">查询</el-button>
                    </slot>
                </el-button-group>
            </div>

            <el-form v-if="showSearchForm" :inline="true" size="mini" class="search-form">

                <slot name="search-form">

                    <el-form-item class="search-form-item" label="审批人">
                        <el-input v-model="searchForm.approved" placeholder="审批人"></el-input>
                    </el-form-item>

                    <el-form-item class="search-form-item" label="活动区域">
                        <el-select v-model="searchForm.place" placeholder="活动区域">
                            <el-option label="区域一" value="shanghai"></el-option>
                            <el-option label="区域二" value="beijing"></el-option>
                        </el-select>
                    </el-form-item>
                </slot>

            </el-form>

            <slot name="table">

                <el-table :data="tableData" >

                    <el-table-column
                            type="selection"
                            width="50">
                    </el-table-column>

                    <el-table-column
                            type="index"
                            width="50">
                    </el-table-column>

                    <el-table-column
                            prop="date"
                            label="日期"
                            width="180">
                    </el-table-column>
                    <el-table-column
                            prop="name"
                            label="姓名"
                            width="180">
                    </el-table-column>
                    <el-table-column
                            prop="address"
                            label="地址">
                    </el-table-column>

                </el-table>

            </slot>


        </fb-main-body>

        <div  v-if="pager.itemCount && showPager" class="pager">
            <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pager.pageIndex"
                    :page-sizes="pagerSizes"
                    :page-size="pager.pageSize"
                    :layout="pagerLayout"
                    :total="pager.itemCount">
            </el-pagination>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ListBody",
        props:{
            btnGroupDirection:{
              type:String,
              default:function () {
                  return 'left';
              }
            },
            showBtnGroup:{
              type:Boolean,
              default:function () {
                  return true
              }
            },inlineBtnGroup:{
              type:Boolean,
              default:function () {
                  return false
              }
            },showPager:{
              type:Boolean,
              default:function () {
                  return true
              }
            },
            showSearchForm:{
              type:Boolean,
              default:function () {
                  return true
              }
            },
           pager:{
               type:Object,
               default:function () {
                   return {
                       pageSize:10,
                       itemCount:1000,
                       pageIndex:5,
                   }
               }
           },
            pagerLayout:{
               type:String,
                default:function () {
                    return "total, sizes, prev, pager, next, jumper";
                }
            },
            pagerSizes:{
               type:Array,
                default:function () {
                    return [10, 20, 50, 100];
                }
            }
        },
        data() {
            return {
                searchForm:{
                    approved:"",
                    place:""
                },
                tableData: [{
                    date: '2016-05-02',
                    name: '王小虎',
                    address: '上海市普陀区金沙江路 1518 弄'
                }, {
                    date: '2016-05-04',
                    name: '王小虎',
                    address: '上海市普陀区金沙江路 1517 弄'
                }, {
                    date: '2016-05-01',
                    name: '王小虎',
                    address: '上海市普陀区金沙江路 1519 弄'
                }, {
                    date: '2016-05-03',
                    name: '王小虎',
                    address: '上海市普陀区金沙江路 1516 弄'
                }, {
                    date: '2016-05-02',
                    name: '王小虎',
                    address: '上海市普陀区金沙江路 1518 弄'
                }, {
                    date: '2016-05-04',
                    name: '王小虎',
                    address: '上海市普陀区金沙江路 1517 弄'
                }, {
                    date: '2016-05-01',
                    name: '王小虎',
                    address: '上海市普陀区金沙江路 1519 弄'
                }, {
                    date: '2016-05-03',
                    name: '王小虎',
                    address: '上海市普陀区金沙江路 1516 弄'
                }, {
                    date: '2016-05-04',
                    name: '王小虎',
                    address: '上海市普陀区金沙江路 1517 弄'
                }, {
                    date: '2016-05-01',
                    name: '王小虎',
                    address: '上海市普陀区金沙江路 1519 弄'
                }]
            }
        },
        methods:{
            handleSizeChange(e){
                this.$emit('handlePagerSizeChange',e);
            }
            ,
            handleCurrentChange(e){
                this.$emit('handlePagerIndexChange',e);
            }
        }
    }
</script>

<style lang="scss" scoped>

    .table-list {
        margin-bottom: 10px;
        margin-top: 10px;
    }

    .search-form{
         /*border-bottom: 1px solid #DCDFE6;*/
    }

    .search-form-item {
        margin-right: 20px;
        margin-bottom: 20px;
    }

    .pager{
        text-align: center;
        margin-top: 10px;
    }

</style>
